import { useState } from 'react';

import { useNavigate } from 'react-router-dom';
import GoogleIcon from '../../images/icon-google.svg';
import {
  signInAuthUserWithEmailAndPassword,
  signInWithGooglePopup
} from '../../utils/firebase/firebase.utils';
import Button from '../button/button.component';
import FormInput from '../form-input/form-input.component';

import './sign-in-form.styles.scss';

const defaultFormFields = {
  email: '',
  password: ''
};

const SignInForm = () => {
  const navigate = useNavigate();

  const [formFields, setFormFields] = useState(defaultFormFields);
  const { email, password } = formFields;

  const resetFormFields = () => {
    setFormFields(defaultFormFields);
  };

  const signInWithGoogle = async () => {
    await signInWithGooglePopup();
    navigate('/');
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      await signInAuthUserWithEmailAndPassword(email, password);
      resetFormFields();
      navigate('/');
    } catch (error) {
      console.log('user sign in failed', error);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormFields({ ...formFields, [name]: value });
  };

  return (
    <div className="auth-card">
      <h2 className="auth-card-title">Déjà un compte ?</h2>
      <p className="auth-card-lead">
        Connectez-vous à l'aide de votre email et de votre mot de passe.
      </p>
      <form onSubmit={handleSubmit}>
        <FormInput
          label="Email"
          type="email"
          required
          onChange={handleChange}
          name="email"
          value={email}
        />

        <FormInput
          label="Mot de passe"
          type="password"
          required
          onChange={handleChange}
          name="password"
          value={password}
        />
        <div className="buttons-container">
          <Button type="submit">Se connecter</Button>
          <p>OU</p>
          <Button className="is-ghost" type="button" onClick={signInWithGoogle}>
            <img className="google-icon" src={GoogleIcon} alt="Logo" />
            Se connecter avec Google
          </Button>
        </div>
      </form>
    </div>
  );
};

export default SignInForm;
